var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{wrapper: !!_vm.currentUser}},[(_vm.currentUser)?_c('navbar'):_vm._e(),_c('router-view'),(_vm.currentUser)?_c('app-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }